"use client"

import { ReactNode } from "react"
import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Loader2, Info, AlertTriangle } from "lucide-react"

export function EmptyState({ title, description, action, icon }: { title: string; description?: string; action?: ReactNode; icon?: ReactNode }) {
    return (
        <Card>
            <CardContent className="p-6 text-center">
                <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-muted">
                    {icon ?? <Info className="h-5 w-5 text-muted-foreground" />}
                </div>
                <div className="text-sm font-medium">{title}</div>
                {description ? <div className="mt-1 text-sm text-muted-foreground">{description}</div> : null}
                {action ? <div className="mt-3">{action}</div> : null}
            </CardContent>
        </Card>
    )
}

export function ErrorState({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
    return (
        <Card>
            <CardContent className="p-6 text-center">
                <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-red-50">
                    <AlertTriangle className="h-5 w-5 text-red-600" />
                </div>
                <div className="text-sm font-medium text-red-700">{title}</div>
                {description ? <div className="mt-1 text-sm text-red-700/80">{description}</div> : null}
                {action ? <div className="mt-3">{action}</div> : null}
            </CardContent>
        </Card>
    )
}

export function LoadingState({ title = "Загрузка..." }: { title?: string }) {
    return (
        <Card>
            <CardContent className="p-6 text-center">
                <div className="inline-flex items-center gap-2 text-sm text-muted-foreground">
                    <Loader2 className="h-4 w-4 animate-spin" />
                    <span>{title}</span>
                </div>
            </CardContent>
        </Card>
    )
}


